"use client";
import React,{useState} from 'react'
import { ProductProvider } from '../components/Productcontext'
import Producthomecontent from '../components/Producthomecontent'
import Footer from '../components/Footer'
import PreHeader from '../components/PreHeader';
import Header from '../components/Header';
import Menu from '../components/Menu';
import  Thordetailscontent from '../components/Thordetailscontent';
import InstallationBanner from '../components/InstallationBanner';
import ProductsubMenu from '../components/ProductsubMenu';
import LightningProductsSubMenu from '../components/LightningProductsSubMenu';

import banner1 from '../images/thordetails/thor_page_banner.jpg';
import banner_360 from '../images/thordetails/thor_page_banner_360.jpg';
import banner_tab from '../images/thordetails/thor_page_banner_tab.jpg';
import banner1_2x from  '../images/thordetails/thor_page_banner@2x.jpg';

// import ProducthomeBanner from '../components/ProducthomeBanner';
// import ban1x from '../images/producthome/product-home-banner.jpg';
// import ban2x from '../images/producthome/product-home-banner@2x.jpg';
const ThorPage = () => {
  const [selectedItem, setSelectedItem] = useState(null);
  const t1=``
  const handleItemClick = (item) => {
    setSelectedItem(item);
    //setIpageValue(item);
    //console.log("set new ipaf vale "+item);
    
  };
    return (
      <div>
           <ProductProvider>
          {/* <PreHeader/>
          <Header/>    
           <Menu/> */}
           <InstallationBanner page="installation" banalt="Ashlok Thor ESE lightning arrester on a mast — NFC 17-102" ashlokAfter={t1} ban1x={banner1} ban2x={banner1_2x} ban360={banner_360} bantab={banner_tab}/>
            <ProductsubMenu/>
            <LightningProductsSubMenu onImageClick={handleItemClick }/>
          
          <Thordetailscontent/>
           
           <Footer/>
           </ProductProvider>
      </div>
    )
  }
  
  export default ThorPage
 
